///
// Plyr slider
///
import Plyr from "plyr";
import debug from "debug";

const log = debug(`storytelling:plyr.js`)

let videoPlayers = [];
let audioPlayers = [];

const optionsVideo = {
  events: {
    play: function (e) {
      log(e, this, videoPlayers);
      if (this.playing) {
        videoPlayers.forEach((element) => {
          element.stop();
        });
      }
    }
  }
};
videoPlayers = Array.from(document.querySelectorAll('.js-videoplayer')).map((p) => new Plyr(p));
videoPlayers.forEach((element) => {
  element.on('play', function (e) {
    stopAllPlayer(e);
  });
});
audioPlayers = Array.from(document.querySelectorAll('.js-audioplayer')).map((p) => new Plyr(p));
audioPlayers.forEach((element) => {
  element.on('play', function (e) {
    stopAllPlayer(e);
  });
});
function stopAllPlayer(event) {
  const player = event.detail.plyr;
  log(event, videoPlayers);
  videoPlayers.forEach((element) => {
    if (player !== element) {
      element.stop();
    }
  });
  audioPlayers.forEach((element) => {
    if (player !== element) {
      element.stop();
    }
  });
};


